.statusPillV2 {
  background-color: var(--light-100);
  border-radius: 6px;
  width: max-content;

  .pill {
    padding: 4px 8px;
    border-radius: 6px;
    border: 1px solid var(--dark-4);
    background: var(--dark-8);
    color: var(--dark-60);
    display: flex;
    align-items: center;
    gap: 4px;
    place-self: flex-start;

    &.xs {
      border-radius: 6px;
      padding: 1px 3px 2px 3px;
    }

    &.connect {
      border: 1px solid var(--dark-8);
      background: #ffc800;
      color: var(--dark-90);
      cursor: pointer;
    }

    &.review,
    &.scheduled {
      border: 1px solid rgba(255, 174, 0, 0.3);
      background: #fbe8b8;
      color: #3f2b00;
    }

    &.approved {
      background: var(--green-10);
      color: var(--green);
    }

    &.failed {
      background: var(--red-10);
      color: var(--red-90);
    }

    &.posted {
      background: var(--upgrade-10);
      color: var(--upgrade);
    }

    &.new {
      background: #d800ec;
      color: var(--light-100);
    }
  }
}
